export default "__VITE_ASSET__KswSqNp2__"